/**
 * Storage URL helpers.
 *
 * The Lovable-era Supabase project (wlfzohsesfgyjbsjsvpy) is frozen and will be
 * deleted. Its files were copied to boumrank-prod (xxnlkrqknitgxnclkefc), but a
 * number of database rows (clients.logo_url, business_profile.logo_url) still
 * point at the old host. We rewrite the host at render time so the UI never
 * depends on the old project, whatever the database says.
 */
const LEGACY_HOSTS = ["wlfzohsesfgyjbsjsvpy.supabase.co"];

const CURRENT_HOST =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/^https?:\/\//, "").replace(/\/$/, "") ||
  "xxnlkrqknitgxnclkefc.supabase.co";

export const resolveStorageUrl = <T extends string | null | undefined>(url: T): T => {
  if (!url) return url;
  let out = url as string;
  for (const host of LEGACY_HOSTS) {
    if (out.includes(host)) out = out.replace(host, CURRENT_HOST);
  }
  return out as T;
};
